import {
  CalendarConfiguration,
  DEFAULT_USER_CONFIGURATION,
  UserConfiguration,
  ExternalProvidersConfiguration
} from '../_models';

/** keys */
export const USER_CONFIGURATION_MODULE_KEY = 'shared/user-configuration';

/** state */
export interface UserConfigurationState extends UserConfiguration {
  readonly userConfigurationId: number;
  readonly calendarConfiguration: CalendarConfiguration;
  readonly externalProvidersConfiguration: ExternalProvidersConfiguration;
}

/** defaults */
export const INITIAL_STATE: UserConfigurationState = {
  userConfigurationId: DEFAULT_USER_CONFIGURATION.userConfigurationId,
  calendarConfiguration: DEFAULT_USER_CONFIGURATION.calendarConfiguration,
  externalProvidersConfiguration: DEFAULT_USER_CONFIGURATION.externalProvidersConfiguration
};
